<div class="search-chat-history" #searchChatHistory [style.maxHeight]="maxHeight">
  @for (item of chatHistoryGrouped; track $index) {
    <span class="p-3 flex text-sm font-bold mt-3">{{item.date| dateAgo}}</span>
    @for (chat of item.histories; track $index) {
      <div class="m-1 p-1 w-12rem">
        <p-button styleClass="w-13rem h-2rem min-w-0 justify-content-between" text="true" plain="true"
        [pTooltip]="chat.heading"
        tooltipPosition="bottom"
        (onClick)="getChatHistoryAndAppend(chat)"
        >
        <span class="text-ellipsis text-sm" [ngClass]="chat.loading ? 'w-10rem' : 'w-12rem'">
          {{chat.heading}}
        </span>
        @if (chat.loading) {
          <i class="pi pi-spin pi-spinner-dotted mr-1" style="font-size: 1rem"></i>
        }
        </p-button>
      </div>
    }
  }
  @empty {
    @if (!isLoading) {
      <div class="flex justify-content-center align-items-center align-content-center gap-1 text-ellipsis mt-3">
        <svg-icon key="info" class="text-lg"></svg-icon>
        <div class="empty-state-text text-sm">No chat history</div>
      </div>
    }
  }
  @if (isLoading) {
    <div class="flex justify-content-center">
      <i class="pi pi-spin pi-spinner-dotted" style="font-size: 1rem"></i>
    </div>
  }
</div>
